module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Guida completa per")]), _vm._v(" "), _c('h1', [_vm._v("comprendere le Dommes della Cina continentale...")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticStyle: {
      "font-size": "xx-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("... per il "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("VERO")]), _vm._v(" uomo "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("sottomesso")]), _vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "font-size": "xx-large",
      "font-weight": "bold"
    }
  }, [_vm._v("Mike Waston")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "x-large",
      "font-weight": "bold"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-digits"
  }, [_vm._v("20")]), _vm._v(" veri consigli ")]), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("DAL MONDO REALE")]), _vm._v(" per conquistare la mistress cinese dei TUOI sogni.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-weight": "bold",
      "page-break-before": "always"
    }
  }, [_vm._v("Copyright 2017 di Mike Watson ("), _c('a', {
    attrs: {
      "href": "http://www.spicyanderoticfetish.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.spicyanderoticfetish.com")]), _vm._v("). Tutti i diritti riservati.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "font-weight": "bold"
    }
  }, [_vm._v("Nessuna parte di questo libro può essere riprodotta senza il previo consenso scritto dell'autore.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0